"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../../../../ts-invariant/process/index.js"),r=require("../../../../graphql/language/source.mjs.js");exports.removeTemporaryGlobals=function(){return r.Source,e.remove()};
//# sourceMappingURL=fix-graphql.js.map
